<template>
  <section id="billing-cases" class="all-cases-view">
    <div class="container-default">
      <div class="add-billing">
        <el-row :gutter="20">
          <el-col :span="17">
            <div class="primary-content-view-new" v-loading="tableLoading">
              <div
                class="listings listings__table listings__all-cases"
                id="all-cases-listings"
              >
                <el-table
                  :data="billingCases"
                  @sort-change="onChangeSort"
                  @selection-change="handleSelectionChange($event)"
                >
                  <el-table-column type="selection" width="40">
                    <template v-slot="scope">
                      <el-checkbox-group
                        :max="3"
                        v-model="multipleSelection"
                        class="checkbox-hidden-label"
                      >
                        <el-checkbox
                          width="50"
                          :label="scope.row.accession_id"
                          :key="scope.row.accession_id"
                        ></el-checkbox>
                      </el-checkbox-group>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="accession_id"
                    label="ACCESSION ID"
                    width="200"
                  >
                    <template #default="scope">
                      <div class="name-accession">
                        <span id="accession-id" v-if="scope.row.accession_id">
                          {{ scope.row.accession_id }}
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="PATIENT NAME"
                    min-width="200"
                    prop="patient_info.first_name"
                  >
                    <template #default="scope">
                      <span class="text-center" v-if="scope.row.patient_info">
                        {{ convertToUppercase(getPatientNameByInfo(scope.row.patient_info)) }}</span
                      >
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="MOBILE NO"
                    prop="home_phone"
                    width="250"
                  >
                    <template #default="scope">
                      <span
                        v-if="
                          scope.row.patient_info &&
                          scope.row.patient_info.home_phone
                        "
                      >
                        {{ scope.row.patient_info.home_phone }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="billing_type"
                    label="BILL TO"
                    width="250"
                  >
                    <template #default="scope">
                      <span class="text-center" v-if="scope.row.billing_type">{{
                        scope.row.billing_type
                      }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="listings listings__pagination">
                <el-pagination
                  v-model:currentPage="page"
                  v-model:page-size="pageSize"
                  :page-sizes="[10, 25, 50, 100]"
                  layout="prev, pager, next, jumper, sizes, total"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </div>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="add-billing-cases-accession-block">
              <div class="accession-block">
                <h3>ENTER ACCESSION ID</h3>
              </div>
              <div>
                <div class="search-filter">
                  <div class="form-element input-with-icon">
                    <el-input
                      placeholder="ENTER ACCESSION ID"
                      v-model="bulkSelectioForm.accession_id"
                      @input="
                        bulkSelectioForm.accession_id =
                          bulkSelectioForm.accession_id.toUpperCase()
                      "
                      :clearable="true"
                      :disabled="multipleInputs"
                    >
                      <template #append>
                        <span>
                          <el-button
                            class="add-btn"
                            @click="addAccession"
                            :disabled="isAddAccessionDisable"
                          >
                            ADD
                          </el-button>
                        </span>
                      </template>
                    </el-input>
                  </div>
                </div>
                <p class="err" v-if="!isPatternMatch">
                  Accepting only alphabets and numbers
                </p>
                <p class="err" v-if="!isAccessionValue">
                  Duplicate Accession Value
                </p>
              </div>

              <div class="accession-block">
                <div class="select-accession">
                  <h4>SELECTED ACCESSION ID'S</h4>
                  <div class="border-bottom"></div>
                </div>
                <ul v-if="!accessionsLoading">
                  <li v-for="(item, index) of multipleSelection" :key="index">
                    <span> {{ item }}</span>
                    <span
                      ><el-button
                        class="icon-btn-danger"
                        @click="removeIndex(item)"
                        >REMOVE</el-button
                      ></span
                    >
                  </li>
                </ul>
                <div class="billing-case-action">
                  <el-button class="btn-cancel-btn" @click="cancel"
                    >CANCEL</el-button
                  >
                  <el-button
                    class="btn-save-btn"
                    @click="onSave"
                    v-loading.fullscreen.lock="sectionLoading"
                    :disabled="multipleSelection.length ? false : true"
                    >SAVE</el-button
                  >
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      page: 1,
      pageSize: 25,
      orderBy: "",
      orderType: "",
      loading: false,
      bulkSelectioForm: {
        accession_id: "",
      },
      multipleSelection: [],
      selectedAccessionIds: [],

      tableLoading: false,
      accessionsLoading: false,
      sectionLoading: false,
      billingCases: [],
      total: 0,
    };
  },
  computed: {
    ...mapGetters("cases", ["getAllCases"]),
    ...mapGetters("billingCases", ["getUpdateCaseBillingStatus"]),
    isPatternMatch() {
      if (!this.bulkSelectioForm.accession_id) return true;

      const pattern = new RegExp(/^[a-z0-9A-Z]*$/);
      return pattern.test(this.bulkSelectioForm.accession_id);
    },
    isAccessionValue() {
      if (
        Object.values(this.multipleSelection).indexOf(
          this.bulkSelectioForm.accession_id
        ) > -1
      ) {
        return false;
      }
      return true;
    },
    isAddAccessionDisable() {
      if (
        this.bulkSelectioForm.accession_id != "" &&
        this.isPatternMatch &&
        this.isAccessionValue
      ) {
        return false;
      }

      return true;
    },
    multipleInputs() {
      if (this.multipleSelection && this.multipleSelection.length == 3) {
        return true;
      }
      return false;
    },
  },
  async mounted() {
    this.setQueryParamsData();
    await this.getPendingbillingCases();
  },
  methods: {
    async onSave() {
      try {
        this.sectionLoading = true;
        this.removeDuplicateAccession();
        let params = {
          accession_ids: this.multipleSelection,
        };
        await this.$store.dispatch("billingCases/addBillingCases", params);
        if (
          this.getUpdateCaseBillingStatus &&
          this.getUpdateCaseBillingStatus.success == true
        ) {
          successNotification("Billing status updated successfully");
          this.multipleSelection = [];
        }
        await this.getPendingbillingCases();
        this.sectionLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async getPendingbillingCases() {
      try {
        this.tableLoading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("cases/fetchAllCases", params);
        this.billingCases = this.getAllCases.data;
        this.total = this.getAllCases.total;
        this.page = this.getAllCases.page;
        this.tableLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    cancel() {
      this.$router.push("/billing-cases");
    },
    removeIndex(accession_id) {
      this.accessionsLoading = true;
      this.multipleSelection = this.multipleSelection.filter((accession) => {
        if (accession_id != accession) {
          return true;
        }
      });
      this.selectedAccessionIds = this.selectedAccessionIds.filter(
        (accession) => {
          if (accession_id != accession) {
            return true;
          }
        }
      );
      this.accessionsLoading = false;
    },
    addAccession() {
      this.accessionsLoading = true;
      this.multipleSelection.push(this.bulkSelectioForm.accession_id);
      this.removeDuplicateAccession();
      this.bulkSelectioForm.accession_id = "";
      this.accessionsLoading = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.accession_id);
      this.multipleSelection = [
        ...this.multipleSelection,
        ...this.selectedAccessionIds,
      ];
      this.removeDuplicateAccession();
    },
    removeDuplicateAccession() {
      let ids = [];
      this.multipleSelection = this.multipleSelection.filter(
        (accession_id) => accession_id && ids.indexOf(accession_id) == -1
      );
    },
    setQueryParamsData() {
      this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1;
      this.pageSize = this.$route.query.limit
        ? parseInt(this.$route.query.limit)
        : 25;
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
        billing_status: "PENDING",
      };
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      return params;
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.getPendingbillingCases();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.getPendingbillingCases();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.getPendingbillingCases();
    },
  },
};
</script>

<style lang="scss">
#billing-cases {
  .add-billing-cases-accession-block {
    h3 {
      font-size: 17px;
      font-weight: 600;
    }
    .accession-block {
      background: #ffffff;
      border: 0.633951px solid #e0e0e0;
      border-radius: 6.33951px;
      margin: 5px 0;
      padding: 5px 10px;
      .select-accession {
        h4 {
          font-size: 15px;
          font-weight: 600;
          padding: 8px 0;
        }
      }
    }
    ul {
      margin-top: 1rem;
      li {
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        color: #25213b;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 5px 0;
        padding: 0 5px 0 15px;
        .icon-btn-danger {
          color: #eb5757;
          font-weight: 600;
          min-height: 30px;

          border: none;
          &:hover {
            background: transparent;
          }
        }
      }
    }
    .billing-case-action {
      text-align: right;
      margin: 10px 0;
      .btn-save-btn {
        background: #273480;
        border-radius: 6.4px;
        color: #ffffff;
        padding: 0 20px;
        min-height: 34px;
        border: none;
      }
      .btn-cancel-btn {
        background: #ffffff;
        color: #273480;
        border-radius: 6.4px;
        padding: 0 20px;
        min-height: 34px;

        border: 0.920987px solid #dedbdb;
      }
    }
  }
  .el-table thead {
    color: rgba(0, 0, 0, 0.8);
    font-size: 12.5px;
    .el-checkbox {
      opacity: 0;
      visibility: hidden;
    }
  }
  .listings__table .el-table table .el-checkbox__input .el-checkbox__inner {
    position: relative;
    top: 5px;
  }
  .search-filter {
    .input-with-icon {
      padding: 0 0 0 10px;
    }
    .el-input-group__append {
      border: none;
      background-color: transparent;
      min-height: 30px;
      height: 34px;
    }
    .add-btn {
      background: #273480;
      border-radius: 4.4px;
      color: #ffffff;
      padding: 0 20px;
      min-height: 34px;
      margin-bottom: -6px;
    }
    .is-disabled {
      opacity: 0.7;
    }
  }
  .border-bottom {
    border-bottom: 1px solid #e7e7f7;
  }
}
</style>
